export const hi = {
  "form.mobile": "मोबाइल नंबर",
  "form.mobile.ph": "10 अंकों का मोबाइल नंबर",
  "form.mobile.hint": "केवल आपकी छवि भेजने और बाद में फिर से पहुँच देने के लिए उपयोग होता है।",
  "form.err.mobile": "कृपया मान्य 10 अंकों का मोबाइल नंबर दर्ज करें।",
  "coupon.have": "कूपन कोड है?",
  "coupon.label": "कूपन कोड",
  "coupon.ph": "कोड लिखें",
  "coupon.apply": "लागू करें",
  "coupon.remove": "हटाएँ",
  "coupon.applied": "कूपन {code} लागू हुआ",
  "coupon.invalid": "यह कूपन कोड अमान्य है या समाप्त हो गया है।",
  "locked.cta.free": "मेरी छवि अनलॉक करें — निःशुल्क",
  "access.link": "मेरी छवि फिर से देखें",
  "access.eyebrow": "पहले खरीदा है?",
  "access.title": "अपनी छवि फिर से पाएँ",
  "access.body": "खरीद के समय उपयोग किया गया मोबाइल नंबर और अपनी जन्म तिथि दर्ज करें, और अपनी दिव्य छवि फिर से खोलें व डाउनलोड करें।",
  "access.cta": "मेरी छवि खोजें",
  "access.hint": "हम इन्हें आपके भुगतान किए गए ऑर्डर से मिलाते हैं। कुछ भी सार्वजनिक नहीं होता।",
  "access.err": "कृपया मान्य मोबाइल नंबर और जन्म तिथि दर्ज करें।",
  "access.notfound": "इस मोबाइल नंबर और जन्म तिथि के लिए कोई भुगतान की गई छवि नहीं मिली।",
  "access.found": "{n} छवि मिली",
  "access.open": "पूरा पृष्ठ खोलें",
  "access.again": "दूसरा नंबर खोजें",
  "nav.how": "यह कैसे काम करता है",
  "nav.experiences": "अनुभव",
  "nav.faq": "प्रश्न",
  "nav.cta": "मेरी छवि खोजें — ₹99",
  "hero.eyebrow": "आपके जन्म विवरण से चुनी गई एक छवि",
  "hero.title.1": "खोजिए अपनी",
  "hero.title.2": "व्यक्तिगत",
  "hero.title.3": "दिव्य छवि",
  "hero.support": "आपका नाम और जन्म विवरण अद्वितीय हैं। SHREE RAGO अपनी ज्योतिष और अंक-विद्या आधारित चयन पद्धति से आपके 7-दिवसीय आध्यात्मिक अनुभव के लिए एक व्यक्तिगत दिव्य छवि पहचानता है।",
  "hero.price.line1": "एक व्यक्तिगत छवि",
  "hero.price.line2": "केवल ₹99",
  "hero.cta": "मेरी छवि खोजें",
  "hero.trust": "लगभग 2 मिनट • सुरक्षित भुगतान • तुरंत डाउनलोड",
  "flow.details": "आपका विवरण",
  "flow.analysis": "SHREE RAGO विश्लेषण",
  "flow.image": "आपकी छवि",
  "curiosity.title": "हर छवि हर व्यक्ति को एक जैसी नहीं लगती।",
  "curiosity.body": "हमारे नाम, जन्म तिथि, जन्म समय और जन्म स्थान अलग-अलग होते हैं। SHREE RAGO इन विवरणों को अपनी अंक-विद्या और ज्योतिष आधारित पद्धति में उपयोग कर आपके व्यक्तिगत आध्यात्मिक अनुभव के लिए एक छवि चुनता है।",
  "curiosity.statement.1": "छवि आप नहीं चुनते।",
  "curiosity.statement.2": "आपका विवरण चयन का मार्ग दिखाता है।",
  "curiosity.cta": "मेरी छवि खोजें — ₹99",
  "how.title": "4 विवरण। 1 छवि। 7 दिन।",
  "how.step1.t": "आपका नाम",
  "how.step1.d": "अपना पूरा नाम लिखें।",
  "how.step2.t": "आपका जन्म विवरण",
  "how.step2.d": "अपनी जन्म तिथि, सही समय और स्थान लिखें।",
  "how.step3.t": "आपकी छवि चुनी जाती है",
  "how.step3.d": "SHREE RAGO आपकी जानकारी को अपनी पूर्वनिर्धारित अंक-विद्या और ज्योतिष आधारित अनुशंसा प्रणाली से संसाधित करता है।",
  "how.step4.t": "डाउनलोड करें और अनुभव करें",
  "how.step4.d": "₹99 का भुगतान करें, अपनी HD छवि डाउनलोड करें और 7 दिनों तक इसे अपने मोबाइल वॉलपेपर के रूप में रखें।",
  "how.cta": "मेरा 7-दिवसीय अनुभव शुरू करें",
  "how.flow.1": "विवरण भरें",
  "how.flow.2": "विश्लेषण",
  "how.flow.3": "₹99 भुगतान",
  "how.flow.4": "डाउनलोड",
  "how.flow.5": "7 दिन",
  "form.title": "आइए आपकी छवि खोजें।",
  "form.subtitle": "नीचे अपना जन्म विवरण भरें।",
  "form.name": "पूरा नाम",
  "form.name.ph": "अपना पूरा नाम लिखें",
  "form.dob": "जन्म तिथि",
  "form.time": "जन्म समय",
  "form.unknown": "मुझे अपना सही जन्म समय नहीं पता",
  "form.place": "जन्म स्थान",
  "form.place.ph": "शहर, राज्य",
  "form.language": "पसंदीदा भाषा",
  "form.submit": "मेरे विवरण का विश्लेषण करें",
  "form.privacy": "आपकी जानकारी केवल आपका परिणाम बनाने के लिए उपयोग की जाती है और हमारी गोपनीयता नीति के अनुसार संभाली जाती है।",
  "form.err.required": "कृपया नाम, जन्म तिथि और जन्म स्थान भरें।",
  "form.err.generic": "कुछ गलत हो गया। कृपया पुनः प्रयास करें।",
  "analysis.1": "आपका जन्म विवरण पढ़ा जा रहा है...",
  "analysis.2": "आपकी अंक-विद्या की गणना हो रही है...",
  "analysis.3": "आपके ज्योतिष इनपुट संसाधित हो रहे हैं...",
  "analysis.4": "आपकी आध्यात्मिक छवि का मिलान हो रहा है...",
  "analysis.5": "आपकी SHREE RAGO छवि पहचान ली गई है।",
  "locked.ready": "आपकी व्यक्तिगत छवि तैयार है।",
  "locked.title": "आपकी छवि प्रतीक्षा कर रही है।",
  "locked.body": "अपनी व्यक्तिगत उच्च-गुणवत्ता दिव्य छवि अनलॉक करें और अपना 7-दिवसीय अनुभव शुरू करें।",
  "locked.cta": "मेरी छवि अनलॉक करें — ₹99",
  "locked.trust": "सुरक्षित भुगतान • तुरंत पहुँच • HD डाउनलोड",
  "pay.title": "ऑर्डर सारांश",
  "pay.item": "SHREE RAGO — व्यक्तिगत दिव्य छवि",
  "pay.total": "कुल",
  "pay.no_hidden": "कोई छिपा शुल्क नहीं।",
  "pay.cta": "₹99 भुगतान करें और अनलॉक करें",
  "pay.success_demo": "भुगतान सफल (डेमो मोड)।",
  "pay.failed": "भुगतान विफल रहा। कृपया पुनः प्रयास करें।",
  "result.title": "आपकी SHREE RAGO छवि",
  "result.selected_for": "इनके लिए चुनी गई",
  "result.download": "HD छवि डाउनलोड करें",
  "result.howto": "उपयोग कैसे करें",
  "result.setwallpaper": "वॉलपेपर के रूप में सेट करें • 7 दिन ध्यान से देखें",
  "result.revealing": "✧ प्रकट हो रही है ✧",
  "result.back": "← मुख्य पृष्ठ पर वापस",
  "common.loading": "लोड हो रहा है…",
  "seven.title": "आपके अगले 7 दिन",
  "seven.i1": "अपनी SHREE RAGO छवि डाउनलोड करें।",
  "seven.i2": "इसे अपने मोबाइल की लॉक स्क्रीन या वॉलपेपर बनाएं।",
  "seven.i3": "अगले 7 दिनों तक इसे रखें।",
  "seven.i4": "हर दिन कुछ क्षण छवि को ध्यान से देखें।",
  "seven.i5": "7वें दिन के अंत में अपने व्यक्तिगत अनुभव पर विचार करें।",
  "seven.motto.1": "7 दिन।",
  "seven.motto.2": "एक छवि।",
  "seven.motto.3": "आपका अनुभव।",
  "seven.cta": "मेरी छवि डाउनलोड करें",
  "trad.title": "परंपरा में निहित। तकनीक से प्रस्तुत।",
  "trad.body": "भारत में ज्योतिष, अंक-विद्या, भक्ति परंपराओं और पवित्र चित्रों की सदियों पुरानी परंपराएँ हैं। SHREE RAGO इन परंपराओं की प्रेरणा को एक सरल डिजिटल अनुभव में लाता है।",
  "collection.title": "भक्ति से रचित। आपके लिए चुनी गई।",
  "collection.sub": "9 अंक-विद्या श्रेणियों में संकलित प्रीमियम 9:16 दिव्य कलाकृतियाँ।",
  "collection.your": "आपकी छवि?",
  "collection.cta": "मेरी छवि खोजें",
  "trust.title": "लोग SHREE RAGO पर क्यों भरोसा करते हैं",
  "testimonials.title": "वास्तविक लोग। वास्तविक अनुभव।",
  "testimonials.sub": "सच्चे साधकों के प्रामाणिक अनुभव।",
  "testimonials.more": "और अनुभव देखें",
  "testimonials.coming": "ग्राहक अनुभव शीघ्र आ रहे हैं।",
  "testimonials.verified": "✓ सत्यापित ग्राहक",
  "why.title": "एक सरल अनुभव। एक सरल मूल्य।",
  "why.body": "कोई सदस्यता नहीं। कोई परामर्श नहीं। कोई जटिल पैकेज नहीं। एक व्यक्तिगत छवि। एक भुगतान। तुरंत डाउनलोड। 7-दिवसीय अनुभव।",
  "why.cta": "मेरी छवि पाएँ — ₹99",
  "privacy.title": "आपका जन्म विवरण व्यक्तिगत है।",
  "privacy.body": "हम केवल सेवा देने के लिए आवश्यक जानकारी ही लेते हैं।",
  "faq.title": "प्रश्न?",
  "faq.q1": "SHREE RAGO क्या है?",
  "faq.a1": "SHREE RAGO एक व्यक्तिगत आध्यात्मिक-छवि अनुभव है, जो आपके दिए गए जन्म विवरण को हमारी अंक-विद्या और ज्योतिष आधारित चयन पद्धति में उपयोग कर आपके लिए एक छवि पहचानता है।",
  "faq.q2": "मुझे कौन-से विवरण चाहिए?",
  "faq.a2": "आपका पूरा नाम, जन्म तिथि, जन्म समय और जन्म स्थान।",
  "faq.q3": "इसकी कीमत क्या है?",
  "faq.a3": "एक व्यक्तिगत उच्च-गुणवत्ता डिजिटल छवि के लिए ₹99।",
  "faq.q4": "मुझे क्या मिलेगा?",
  "faq.a4": "आपको एक व्यक्तिगत दिव्य छवि मिलती है जिसे आप अपने मोबाइल में डाउनलोड कर सकते हैं।",
  "faq.q5": "मैं इसका उपयोग कैसे करूँ?",
  "faq.a5": "डाउनलोड की गई छवि को 7 दिनों तक अपने मोबाइल वॉलपेपर या लॉक स्क्रीन के रूप में रखें और अपने व्यक्तिगत अनुभव को देखें।",
  "faq.q6": "क्या मुझे निश्चित रूप से कोई विशेष परिणाम मिलेगा?",
  "faq.a6": "व्यक्तिगत अनुभव अलग-अलग होते हैं। SHREE RAGO एक आध्यात्मिक और आत्म-चिंतन अनुभव है और यह आर्थिक, चिकित्सा, संबंध, करियर या किसी अन्य विशेष परिणाम की गारंटी नहीं देता।",
  "faq.q7": "क्या यह चिकित्सा या वित्तीय सलाह है?",
  "faq.a7": "नहीं। SHREE RAGO किसी भी पेशेवर चिकित्सा, मनोवैज्ञानिक, वित्तीय, कानूनी या अन्य सलाह का विकल्प नहीं है।",
  "faq.q8": "क्या मैं इसे तुरंत डाउनलोड कर सकता/सकती हूँ?",
  "faq.a8": "हाँ। सफल भुगतान के बाद आपकी छवि तुरंत डाउनलोड के लिए उपलब्ध हो जाती है।",
  "faq.q9": "क्या मैं अपनी छवि साझा कर सकता/सकती हूँ?",
  "faq.a9": "खरीदी गई छवि ग्राहक के व्यक्तिगत उपयोग के लिए लाइसेंस प्राप्त है। साझा करते समय अपनी व्यक्तिगत जन्म जानकारी उजागर न करें।",
  "final.title": "आपका विवरण अद्वितीय है।",
  "final.sub": "अपने 7-दिवसीय SHREE RAGO अनुभव के लिए चुनी गई छवि खोजें।",
  "final.cta": "मेरी छवि खोजें",
  "final.trust": "2 मिनट • सुरक्षित भुगतान • तुरंत डाउनलोड",
  "footer.tagline": "आपकी व्यक्तिगत दिव्य छवि",
  "footer.disclaimer": "SHREE RAGO एक आध्यात्मिक और आत्म-चिंतन अनुभव प्रदान करता है। ज्योतिष और अंक-विद्या की व्याख्याएँ आस्था-आधारित हैं और इन्हें निश्चित भविष्यवाणी या पेशेवर सलाह का विकल्प नहीं माना जाना चाहिए।",
  "footer.how": "यह कैसे काम करता है",
  "footer.faq": "प्रश्न",
  "footer.privacy": "गोपनीयता नीति",
  "footer.terms": "नियम व शर्तें",
  "footer.shipping": "शिपिंग व डिलीवरी",
  "footer.refund": "रिफंड व रद्दीकरण",
  "footer.contact": "संपर्क",
  "footer.rights": "सर्वाधिकार सुरक्षित।",
  "trust.oneprice.t": "एक स्पष्ट मूल्य",
  "trust.oneprice.d": "₹99। कोई छिपी सदस्यता नहीं। कोई आवर्ती भुगतान नहीं।",
  "trust.personal.t": "आपकी व्यक्तिगत छवि",
  "trust.personal.d": "आपका परिणाम आपके दिए गए जन्म विवरण से गणना कर SHREE RAGO प्रणाली से मैप किया जाता है।",
  "trust.secure.t": "सुरक्षित भुगतान",
  "trust.secure.d": "भुगतान निर्धारित भुगतान प्रदाता के माध्यम से सुरक्षित रूप से संसाधित होते हैं।",
  "trust.instant.t": "तुरंत पहुँच",
  "trust.instant.d": "सत्यापित भुगतान के बाद आपकी चुनी गई छवि डाउनलोड के लिए उपलब्ध हो जाती है।",
  "trust.access.t": "फिर से पहुँच",
  "trust.access.d": "अपनी खरीदी गई छवि को फिर से पाने के लिए अपने सत्यापित मोबाइल नंबर का उपयोग करें।",
  "trust.refund.t": "7-दिवसीय संतुष्टि वचन",
  "trust.refund.d": "पात्र रिफंड अनुरोध प्रकाशित रिफंड नीति के अनुसार 7 दिनों के भीतर किए जा सकते हैं।",
  "trust.privacy.t": "आपकी गोपनीयता महत्वपूर्ण है",
  "trust.privacy.d": "जन्म विवरण और व्यक्तिगत जानकारी गोपनीयता नीति के अनुसार संभाली जाती है और सार्वजनिक रूप से प्रदर्शित नहीं की जाती।",
  "lang.choose": "अपनी भाषा चुनें",
  "purchase.title": "₹99 में आपको क्या मिलता है",
  "purchase.i1": "एक व्यक्तिगत दिव्य छवि",
  "purchase.i2": "उच्च-गुणवत्ता मोबाइल डाउनलोड",
  "purchase.i3": "आपका 7-दिवसीय SHREE RAGO अनुभव",
  "purchase.i4": "सत्यापित मोबाइल नंबर से फिर से पहुँच",
  "purchase.i5": "पात्र 7-दिवसीय रिफंड अनुरोध",
  "purchase.onetime": "एक बार का भुगतान",
  "purchase.nosubs": "कोई सदस्यता नहीं",
  "purchase.secure": "🔒 सुरक्षित भुगतान • ₹99 एक बार • 7-दिवसीय रिफंड नीति • HD डाउनलोड",
};

export const kn = {
  "form.mobile": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
  "form.mobile.ph": "10 ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
  "form.mobile.hint": "ನಿಮ್ಮ ಚಿತ್ರ ಕಳುಹಿಸಲು ಮತ್ತು ನಂತರ ಮತ್ತೆ ಪ್ರವೇಶಿಸಲು ಮಾತ್ರ ಬಳಸಲಾಗುತ್ತದೆ.",
  "form.err.mobile": "ದಯವಿಟ್ಟು ಮಾನ್ಯ 10 ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ.",
  "coupon.have": "ಕೂಪನ್ ಕೋಡ್ ಇದೆಯೇ?",
  "coupon.label": "ಕೂಪನ್ ಕೋಡ್",
  "coupon.ph": "ಕೋಡ್ ನಮೂದಿಸಿ",
  "coupon.apply": "ಅನ್ವಯಿಸಿ",
  "coupon.remove": "ತೆಗೆದುಹಾಕಿ",
  "coupon.applied": "ಕೂಪನ್ {code} ಅನ್ವಯಿಸಲಾಗಿದೆ",
  "coupon.invalid": "ಈ ಕೂಪನ್ ಕೋಡ್ ಅಮಾನ್ಯ ಅಥವಾ ಅವಧಿ ಮುಗಿದಿದೆ.",
  "locked.cta.free": "ನನ್ನ ಚಿತ್ರ ಅನ್‌ಲಾಕ್ ಮಾಡಿ — ಉಚಿತ",
  "access.link": "ನನ್ನ ಚಿತ್ರ ಮತ್ತೆ ನೋಡಿ",
  "access.eyebrow": "ಈಗಾಗಲೇ ಖರೀದಿಸಿದ್ದೀರಾ?",
  "access.title": "ನಿಮ್ಮ ಚಿತ್ರವನ್ನು ಮತ್ತೆ ಪಡೆಯಿರಿ",
  "access.body": "ಖರೀದಿಯ ಸಮಯದಲ್ಲಿ ಬಳಸಿದ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಮತ್ತು ನಿಮ್ಮ ಜನ್ಮ ದಿನಾಂಕ ನಮೂದಿಸಿ, ನಿಮ್ಮ ದೈವಿಕ ಚಿತ್ರವನ್ನು ಮತ್ತೆ ತೆರೆದು ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ.",
  "access.cta": "ನನ್ನ ಚಿತ್ರ ಹುಡುಕಿ",
  "access.hint": "ಇವುಗಳನ್ನು ನಿಮ್ಮ ಪಾವತಿಸಿದ ಆರ್ಡರ್‌ನೊಂದಿಗೆ ಹೊಂದಿಸುತ್ತೇವೆ. ಯಾವುದೂ ಸಾರ್ವಜನಿಕವಾಗುವುದಿಲ್ಲ.",
  "access.err": "ದಯವಿಟ್ಟು ಮಾನ್ಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಮತ್ತು ಜನ್ಮ ದಿನಾಂಕ ನಮೂದಿಸಿ.",
  "access.notfound": "ಈ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಮತ್ತು ಜನ್ಮ ದಿನಾಂಕಕ್ಕೆ ಪಾವತಿಸಿದ ಚಿತ್ರ ಸಿಗಲಿಲ್ಲ.",
  "access.found": "{n} ಚಿತ್ರ ಸಿಕ್ಕಿದೆ",
  "access.open": "ಪೂರ್ಣ ಪುಟ ತೆರೆಯಿರಿ",
  "access.again": "ಬೇರೆ ಸಂಖ್ಯೆ ಹುಡುಕಿ",
  "nav.how": "ಇದು ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ",
  "nav.experiences": "ಅನುಭವಗಳು",
  "nav.faq": "ಪ್ರಶ್ನೆಗಳು",
  "nav.cta": "ನನ್ನ ಚಿತ್ರ ಹುಡುಕಿ — ₹99",
  "hero.eyebrow": "ನಿಮ್ಮ ಜನ್ಮ ವಿವರಗಳಿಂದ ಆಯ್ಕೆಯಾದ ಚಿತ್ರ",
  "hero.title.1": "ಹುಡುಕಿ ನಿಮ್ಮ",
  "hero.title.2": "ವೈಯಕ್ತಿಕ",
  "hero.title.3": "ದೈವಿಕ ಚಿತ್ರ",
  "hero.support": "ನಿಮ್ಮ ಹೆಸರು ಮತ್ತು ಜನ್ಮ ವಿವರಗಳು ವಿಶಿಷ್ಟ. SHREE RAGO ತನ್ನ ಜ್ಯೋತಿಷ್ಯ ಮತ್ತು ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ಆಧಾರಿತ ಆಯ್ಕೆ ವಿಧಾನದಿಂದ ನಿಮ್ಮ 7-ದಿನಗಳ ಆಧ್ಯಾತ್ಮಿಕ ಅನುಭವಕ್ಕಾಗಿ ಒಂದು ವೈಯಕ್ತಿಕ ದೈವಿಕ ಚಿತ್ರವನ್ನು ಗುರುತಿಸುತ್ತದೆ.",
  "hero.price.line1": "ಒಂದು ವೈಯಕ್ತಿಕ ಚಿತ್ರ",
  "hero.price.line2": "ಕೇವಲ ₹99",
  "hero.cta": "ನನ್ನ ಚಿತ್ರ ಹುಡುಕಿ",
  "hero.trust": "ಸುಮಾರು 2 ನಿಮಿಷ • ಸುರಕ್ಷಿತ ಪಾವತಿ • ತಕ್ಷಣ ಡೌನ್‌ಲೋಡ್",
  "flow.details": "ನಿಮ್ಮ ವಿವರಗಳು",
  "flow.analysis": "SHREE RAGO ವಿಶ್ಲೇಷಣೆ",
  "flow.image": "ನಿಮ್ಮ ಚಿತ್ರ",
  "curiosity.title": "ಪ್ರತಿಯೊಂದು ಚಿತ್ರವೂ ಪ್ರತಿಯೊಬ್ಬರಿಗೂ ಒಂದೇ ರೀತಿ ಅನಿಸಬೇಕಿಲ್ಲ.",
  "curiosity.body": "ನಮ್ಮ ಹೆಸರು, ಜನ್ಮ ದಿನಾಂಕ, ಜನ್ಮ ಸಮಯ ಮತ್ತು ಜನ್ಮ ಸ್ಥಳ ಬೇರೆ ಬೇರೆ. SHREE RAGO ಈ ವಿವರಗಳನ್ನು ತನ್ನ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ಮತ್ತು ಜ್ಯೋತಿಷ್ಯ ಆಧಾರಿತ ವಿಧಾನದಲ್ಲಿ ಬಳಸಿ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಆಧ್ಯಾತ್ಮಿಕ ಅನುಭವಕ್ಕಾಗಿ ಒಂದು ಚಿತ್ರವನ್ನು ಆಯ್ಕೆ ಮಾಡುತ್ತದೆ.",
  "curiosity.statement.1": "ಚಿತ್ರವನ್ನು ನೀವು ಆರಿಸುವುದಿಲ್ಲ.",
  "curiosity.statement.2": "ನಿಮ್ಮ ವಿವರಗಳು ಆಯ್ಕೆಗೆ ದಾರಿ ತೋರಿಸುತ್ತವೆ.",
  "curiosity.cta": "ನನ್ನ ಚಿತ್ರ ಹುಡುಕಿ — ₹99",
  "how.title": "4 ವಿವರಗಳು. 1 ಚಿತ್ರ. 7 ದಿನಗಳು.",
  "how.step1.t": "ನಿಮ್ಮ ಹೆಸರು",
  "how.step1.d": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ.",
  "how.step2.t": "ನಿಮ್ಮ ಜನ್ಮ ವಿವರಗಳು",
  "how.step2.d": "ನಿಮ್ಮ ಜನ್ಮ ದಿನಾಂಕ, ನಿಖರ ಸಮಯ ಮತ್ತು ಸ್ಥಳವನ್ನು ನಮೂದಿಸಿ.",
  "how.step3.t": "ನಿಮ್ಮ ಚಿತ್ರ ಆಯ್ಕೆಯಾಗುತ್ತದೆ",
  "how.step3.d": "SHREE RAGO ನಿಮ್ಮ ಮಾಹಿತಿಯನ್ನು ತನ್ನ ಪೂರ್ವನಿರ್ಧರಿತ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ಮತ್ತು ಜ್ಯೋತಿಷ್ಯ ಆಧಾರಿತ ಶಿಫಾರಸು ವ್ಯವಸ್ಥೆಯ ಮೂಲಕ ಸಂಸ್ಕರಿಸುತ್ತದೆ.",
  "how.step4.t": "ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ ಅನುಭವಿಸಿ",
  "how.step4.d": "₹99 ಪಾವತಿಸಿ, ನಿಮ್ಮ HD ಚಿತ್ರವನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ ಮತ್ತು 7 ದಿನಗಳವರೆಗೆ ನಿಮ್ಮ ಮೊಬೈಲ್ ವಾಲ್‌ಪೇಪರ್ ಆಗಿ ಇರಿಸಿ.",
  "how.cta": "ನನ್ನ 7-ದಿನಗಳ ಅನುಭವ ಪ್ರಾರಂಭಿಸಿ",
  "how.flow.1": "ವಿವರ ನಮೂದಿಸಿ",
  "how.flow.2": "ವಿಶ್ಲೇಷಣೆ",
  "how.flow.3": "₹99 ಪಾವತಿ",
  "how.flow.4": "ಡೌನ್‌ಲೋಡ್",
  "how.flow.5": "7 ದಿನಗಳು",
  "form.title": "ನಿಮ್ಮ ಚಿತ್ರ ಹುಡುಕೋಣ.",
  "form.subtitle": "ಕೆಳಗೆ ನಿಮ್ಮ ಜನ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ.",
  "form.name": "ಪೂರ್ಣ ಹೆಸರು",
  "form.name.ph": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
  "form.dob": "ಜನ್ಮ ದಿನಾಂಕ",
  "form.time": "ಜನ್ಮ ಸಮಯ",
  "form.unknown": "ನನ್ನ ನಿಖರ ಜನ್ಮ ಸಮಯ ನನಗೆ ತಿಳಿದಿಲ್ಲ",
  "form.place": "ಜನ್ಮ ಸ್ಥಳ",
  "form.place.ph": "ನಗರ, ರಾಜ್ಯ",
  "form.language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
  "form.submit": "ನನ್ನ ವಿವರಗಳನ್ನು ವಿಶ್ಲೇಷಿಸಿ",
  "form.privacy": "ನಿಮ್ಮ ಮಾಹಿತಿಯನ್ನು ನಿಮ್ಮ ಫಲಿತಾಂಶ ರಚಿಸಲು ಮಾತ್ರ ಬಳಸಲಾಗುತ್ತದೆ ಮತ್ತು ನಮ್ಮ ಗೌಪ್ಯತಾ ನೀತಿಯ ಪ್ರಕಾರ ನಿರ್ವಹಿಸಲಾಗುತ್ತದೆ.",
  "form.err.required": "ದಯವಿಟ್ಟು ಹೆಸರು, ಜನ್ಮ ದಿನಾಂಕ ಮತ್ತು ಜನ್ಮ ಸ್ಥಳವನ್ನು ಭರ್ತಿ ಮಾಡಿ.",
  "form.err.generic": "ಏನೋ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  "analysis.1": "ನಿಮ್ಮ ಜನ್ಮ ವಿವರಗಳನ್ನು ಓದಲಾಗುತ್ತಿದೆ...",
  "analysis.2": "ನಿಮ್ಮ ಸಂಖ್ಯಾಶಾಸ್ತ್ರವನ್ನು ಲೆಕ್ಕ ಹಾಕಲಾಗುತ್ತಿದೆ...",
  "analysis.3": "ನಿಮ್ಮ ಜ್ಯೋತಿಷ್ಯ ಮಾಹಿತಿಯನ್ನು ಸಂಸ್ಕರಿಸಲಾಗುತ್ತಿದೆ...",
  "analysis.4": "ನಿಮ್ಮ ಆಧ್ಯಾತ್ಮಿಕ ಚಿತ್ರವನ್ನು ಹೊಂದಿಸಲಾಗುತ್ತಿದೆ...",
  "analysis.5": "ನಿಮ್ಮ SHREE RAGO ಚಿತ್ರ ಗುರುತಿಸಲಾಗಿದೆ.",
  "locked.ready": "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಚಿತ್ರ ಸಿದ್ಧವಾಗಿದೆ.",
  "locked.title": "ನಿಮ್ಮ ಚಿತ್ರ ಕಾಯುತ್ತಿದೆ.",
  "locked.body": "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಉನ್ನತ-ಗುಣಮಟ್ಟದ ದೈವಿಕ ಚಿತ್ರವನ್ನು ಅನ್‌ಲಾಕ್ ಮಾಡಿ ಮತ್ತು ನಿಮ್ಮ 7-ದಿನಗಳ ಅನುಭವ ಪ್ರಾರಂಭಿಸಿ.",
  "locked.cta": "ನನ್ನ ಚಿತ್ರ ಅನ್‌ಲಾಕ್ ಮಾಡಿ — ₹99",
  "locked.trust": "ಸುರಕ್ಷಿತ ಪಾವತಿ • ತಕ್ಷಣ ಪ್ರವೇಶ • HD ಡೌನ್‌ಲೋಡ್",
  "pay.title": "ಆರ್ಡರ್ ಸಾರಾಂಶ",
  "pay.item": "SHREE RAGO — ವೈಯಕ್ತಿಕ ದೈವಿಕ ಚಿತ್ರ",
  "pay.total": "ಒಟ್ಟು",
  "pay.no_hidden": "ಯಾವುದೇ ಗುಪ್ತ ಶುಲ್ಕವಿಲ್ಲ.",
  "pay.cta": "₹99 ಪಾವತಿಸಿ ಅನ್‌ಲಾಕ್ ಮಾಡಿ",
  "pay.success_demo": "ಪಾವತಿ ಯಶಸ್ವಿ (ಡೆಮೊ ಮೋಡ್).",
  "pay.failed": "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  "result.title": "ನಿಮ್ಮ SHREE RAGO ಚಿತ್ರ",
  "result.selected_for": "ಇವರಿಗಾಗಿ ಆಯ್ಕೆಯಾಗಿದೆ",
  "result.download": "HD ಚಿತ್ರ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
  "result.howto": "ಹೇಗೆ ಬಳಸಬೇಕು",
  "result.setwallpaper": "ವಾಲ್‌ಪೇಪರ್ ಆಗಿ ಇರಿಸಿ • 7 ದಿನಗಳು ಗಮನಿಸಿ",
  "result.revealing": "✧ ಪ್ರಕಟವಾಗುತ್ತಿದೆ ✧",
  "result.back": "← ಮುಖಪುಟಕ್ಕೆ ಹಿಂತಿರುಗಿ",
  "common.loading": "ಲೋಡ್ ಆಗುತ್ತಿದೆ…",
  "seven.title": "ನಿಮ್ಮ ಮುಂದಿನ 7 ದಿನಗಳು",
  "seven.i1": "ನಿಮ್ಮ SHREE RAGO ಚಿತ್ರವನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ.",
  "seven.i2": "ಅದನ್ನು ನಿಮ್ಮ ಮೊಬೈಲ್ ಲಾಕ್ ಸ್ಕ್ರೀನ್ ಅಥವಾ ವಾಲ್‌ಪೇಪರ್ ಆಗಿ ಇರಿಸಿ.",
  "seven.i3": "ಮುಂದಿನ 7 ದಿನಗಳವರೆಗೆ ಅದನ್ನು ಇರಿಸಿಕೊಳ್ಳಿ.",
  "seven.i4": "ಪ್ರತಿದಿನ ಒಂದು ಕ್ಷಣ ಚಿತ್ರವನ್ನು ಶ್ರದ್ಧೆಯಿಂದ ಗಮನಿಸಿ.",
  "seven.i5": "7ನೇ ದಿನದ ಕೊನೆಯಲ್ಲಿ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಅನುಭವವನ್ನು ಅವಲೋಕಿಸಿ.",
  "seven.motto.1": "7 ದಿನಗಳು.",
  "seven.motto.2": "ಒಂದು ಚಿತ್ರ.",
  "seven.motto.3": "ನಿಮ್ಮ ಅನುಭವ.",
  "seven.cta": "ನನ್ನ ಚಿತ್ರ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
  "trad.title": "ಪರಂಪರೆಯಲ್ಲಿ ಬೇರೂರಿದೆ. ತಂತ್ರಜ್ಞಾನದ ಮೂಲಕ ತಲುಪಿಸಲಾಗಿದೆ.",
  "trad.body": "ಭಾರತದಲ್ಲಿ ಜ್ಯೋತಿಷ್ಯ, ಸಂಖ್ಯಾಶಾಸ್ತ್ರ, ಭಕ್ತಿ ಆಚರಣೆಗಳು ಮತ್ತು ಪವಿತ್ರ ಚಿತ್ರಗಳ ಶತಮಾನಗಳ ಹಳೆಯ ಪರಂಪರೆಗಳಿವೆ. SHREE RAGO ಈ ಪರಂಪರೆಗಳ ಸ್ಫೂರ್ತಿಯನ್ನು ಒಂದು ಸರಳ ಡಿಜಿಟಲ್ ಅನುಭವಕ್ಕೆ ತರುತ್ತದೆ.",
  "collection.title": "ಭಕ್ತಿಯಿಂದ ರಚಿಸಲಾಗಿದೆ. ನಿಮಗಾಗಿ ಆಯ್ಕೆಯಾಗಿದೆ.",
  "collection.sub": "9 ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ವರ್ಗಗಳಲ್ಲಿ ಸಂಗ್ರಹಿಸಿದ ಪ್ರೀಮಿಯಂ 9:16 ದೈವಿಕ ಕಲಾಕೃತಿಗಳು.",
  "collection.your": "ನಿಮ್ಮ ಚಿತ್ರ?",
  "collection.cta": "ನನ್ನದನ್ನು ಹುಡುಕಿ",
  "trust.title": "ಜನರು SHREE RAGO ಅನ್ನು ಏಕೆ ನಂಬುತ್ತಾರೆ",
  "testimonials.title": "ನಿಜವಾದ ಜನರು. ನಿಜವಾದ ಅನುಭವಗಳು.",
  "testimonials.sub": "ನಿಜವಾದ ಸಾಧಕರ ಪ್ರಾಮಾಣಿಕ ಅನುಭವಗಳು.",
  "testimonials.more": "ಇನ್ನಷ್ಟು ಅನುಭವಗಳನ್ನು ನೋಡಿ",
  "testimonials.coming": "ಗ್ರಾಹಕರ ಅನುಭವಗಳು ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿವೆ.",
  "testimonials.verified": "✓ ಪರಿಶೀಲಿತ ಗ್ರಾಹಕ",
  "why.title": "ಸರಳ ಅನುಭವ. ಸರಳ ಬೆಲೆ.",
  "why.body": "ಚಂದಾದಾರಿಕೆ ಇಲ್ಲ. ಸಮಾಲೋಚನೆ ಇಲ್ಲ. ಸಂಕೀರ್ಣ ಪ್ಯಾಕೇಜ್‌ಗಳಿಲ್ಲ. ಒಂದು ವೈಯಕ್ತಿಕ ಚಿತ್ರ. ಒಂದು ಪಾವತಿ. ತಕ್ಷಣ ಡೌನ್‌ಲೋಡ್. 7-ದಿನಗಳ ಅನುಭವ.",
  "why.cta": "ನನ್ನ ಚಿತ್ರ ಪಡೆಯಿರಿ — ₹99",
  "privacy.title": "ನಿಮ್ಮ ಜನ್ಮ ವಿವರಗಳು ವೈಯಕ್ತಿಕ.",
  "privacy.body": "ಸೇವೆ ನೀಡಲು ಅಗತ್ಯವಿರುವ ಮಾಹಿತಿಯನ್ನು ಮಾತ್ರ ನಾವು ಸಂಗ್ರಹಿಸುತ್ತೇವೆ.",
  "faq.title": "ಪ್ರಶ್ನೆಗಳು?",
  "faq.q1": "SHREE RAGO ಎಂದರೇನು?",
  "faq.a1": "SHREE RAGO ಒಂದು ವೈಯಕ್ತಿಕ ಆಧ್ಯಾತ್ಮಿಕ-ಚಿತ್ರ ಅನುಭವ. ನೀವು ನೀಡುವ ಜನ್ಮ ವಿವರಗಳನ್ನು ನಮ್ಮ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ ಮತ್ತು ಜ್ಯೋತಿಷ್ಯ ಆಧಾರಿತ ಆಯ್ಕೆ ವಿಧಾನದಲ್ಲಿ ಬಳಸಿ ನಿಮಗಾಗಿ ಒಂದು ಚಿತ್ರವನ್ನು ಗುರುತಿಸುತ್ತದೆ.",
  "faq.q2": "ನನಗೆ ಯಾವ ವಿವರಗಳು ಬೇಕು?",
  "faq.a2": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರು, ಜನ್ಮ ದಿನಾಂಕ, ಜನ್ಮ ಸಮಯ ಮತ್ತು ಜನ್ಮ ಸ್ಥಳ.",
  "faq.q3": "ಇದರ ಬೆಲೆ ಎಷ್ಟು?",
  "faq.a3": "ಒಂದು ವೈಯಕ್ತಿಕ ಉನ್ನತ-ಗುಣಮಟ್ಟದ ಡಿಜಿಟಲ್ ಚಿತ್ರಕ್ಕೆ ₹99.",
  "faq.q4": "ನನಗೆ ಏನು ಸಿಗುತ್ತದೆ?",
  "faq.a4": "ನಿಮ್ಮ ಮೊಬೈಲ್‌ಗೆ ಡೌನ್‌ಲೋಡ್ ಮಾಡಬಹುದಾದ ಒಂದು ವೈಯಕ್ತಿಕ ದೈವಿಕ ಚಿತ್ರ ನಿಮಗೆ ಸಿಗುತ್ತದೆ.",
  "faq.q5": "ನಾನು ಇದನ್ನು ಹೇಗೆ ಬಳಸಬೇಕು?",
  "faq.a5": "ಡೌನ್‌ಲೋಡ್ ಮಾಡಿದ ಚಿತ್ರವನ್ನು 7 ದಿನಗಳವರೆಗೆ ನಿಮ್ಮ ಮೊಬೈಲ್ ವಾಲ್‌ಪೇಪರ್ ಅಥವಾ ಲಾಕ್ ಸ್ಕ್ರೀನ್ ಆಗಿ ಇರಿಸಿ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಅನುಭವವನ್ನು ಗಮನಿಸಿ.",
  "faq.q6": "ನನಗೆ ಖಚಿತವಾಗಿ ಒಂದು ನಿರ್ದಿಷ್ಟ ಫಲಿತಾಂಶ ಸಿಗುತ್ತದೆಯೇ?",
  "faq.a6": "ವ್ಯಕ್ತಿಗತ ಅನುಭವಗಳು ಬೇರೆ ಬೇರೆ. SHREE RAGO ಒಂದು ಆಧ್ಯಾತ್ಮಿಕ ಮತ್ತು ಆತ್ಮಾವಲೋಕನ ಅನುಭವ; ಇದು ಆರ್ಥಿಕ, ವೈದ್ಯಕೀಯ, ಸಂಬಂಧ, ವೃತ್ತಿ ಅಥವಾ ಯಾವುದೇ ನಿರ್ದಿಷ್ಟ ಫಲಿತಾಂಶದ ಭರವಸೆ ನೀಡುವುದಿಲ್ಲ.",
  "faq.q7": "ಇದು ವೈದ್ಯಕೀಯ ಅಥವಾ ಆರ್ಥಿಕ ಸಲಹೆಯೇ?",
  "faq.a7": "ಇಲ್ಲ. SHREE RAGO ವೃತ್ತಿಪರ ವೈದ್ಯಕೀಯ, ಮಾನಸಿಕ, ಆರ್ಥಿಕ, ಕಾನೂನು ಅಥವಾ ಇತರ ಸಲಹೆಗೆ ಪರ್ಯಾಯವಲ್ಲ.",
  "faq.q8": "ನಾನು ತಕ್ಷಣ ಡೌನ್‌ಲೋಡ್ ಮಾಡಬಹುದೇ?",
  "faq.a8": "ಹೌದು. ಯಶಸ್ವಿ ಪಾವತಿಯ ನಂತರ ನಿಮ್ಮ ಚಿತ್ರ ತಕ್ಷಣ ಡೌನ್‌ಲೋಡ್‌ಗೆ ಲಭ್ಯವಾಗುತ್ತದೆ.",
  "faq.q9": "ನನ್ನ ಚಿತ್ರವನ್ನು ಹಂಚಿಕೊಳ್ಳಬಹುದೇ?",
  "faq.a9": "ಖರೀದಿಸಿದ ಚಿತ್ರ ಗ್ರಾಹಕರ ವೈಯಕ್ತಿಕ ಬಳಕೆಗೆ ಪರವಾನಗಿ ಪಡೆದಿದೆ. ಹಂಚಿಕೊಳ್ಳುವಾಗ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಜನ್ಮ ಮಾಹಿತಿಯನ್ನು ಬಹಿರಂಗಪಡಿಸಬೇಡಿ.",
  "final.title": "ನಿಮ್ಮ ವಿವರಗಳು ವಿಶಿಷ್ಟ.",
  "final.sub": "ನಿಮ್ಮ 7-ದಿನಗಳ SHREE RAGO ಅನುಭವಕ್ಕಾಗಿ ಆಯ್ಕೆಯಾದ ಚಿತ್ರವನ್ನು ಹುಡುಕಿ.",
  "final.cta": "ನನ್ನ ಚಿತ್ರ ಹುಡುಕಿ",
  "final.trust": "2 ನಿಮಿಷ • ಸುರಕ್ಷಿತ ಪಾವತಿ • ತಕ್ಷಣ ಡೌನ್‌ಲೋಡ್",
  "footer.tagline": "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ದೈವಿಕ ಚಿತ್ರ",
  "footer.disclaimer": "SHREE RAGO ಒಂದು ಆಧ್ಯಾತ್ಮಿಕ ಮತ್ತು ಆತ್ಮಾವಲೋಕನ ಅನುಭವವನ್ನು ನೀಡುತ್ತದೆ. ಜ್ಯೋತಿಷ್ಯ ಮತ್ತು ಸಂಖ್ಯಾಶಾಸ್ತ್ರದ ವ್ಯಾಖ್ಯಾನಗಳು ನಂಬಿಕೆ ಆಧಾರಿತ; ಅವುಗಳನ್ನು ಖಚಿತ ಭವಿಷ್ಯವಾಣಿ ಅಥವಾ ವೃತ್ತಿಪರ ಸಲಹೆಗೆ ಪರ್ಯಾಯವೆಂದು ಪರಿಗಣಿಸಬಾರದು.",
  "footer.how": "ಇದು ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ",
  "footer.faq": "ಪ್ರಶ್ನೆಗಳು",
  "footer.privacy": "ಗೌಪ್ಯತಾ ನೀತಿ",
  "footer.terms": "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
  "footer.shipping": "ಶಿಪ್ಪಿಂಗ್ ಮತ್ತು ವಿತರಣೆ",
  "footer.refund": "ಮರುಪಾವತಿ ಮತ್ತು ರದ್ದತಿ",
  "footer.contact": "ಸಂಪರ್ಕ",
  "footer.rights": "ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
  "trust.oneprice.t": "ಒಂದು ಸ್ಪಷ್ಟ ಬೆಲೆ",
  "trust.oneprice.d": "₹99. ಗುಪ್ತ ಚಂದಾದಾರಿಕೆ ಇಲ್ಲ. ಪುನರಾವರ್ತಿತ ಪಾವತಿ ಇಲ್ಲ.",
  "trust.personal.t": "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಚಿತ್ರ",
  "trust.personal.d": "ನೀವು ನೀಡುವ ಜನ್ಮ ಮಾಹಿತಿಯಿಂದ ನಿಮ್ಮ ಫಲಿತಾಂಶವನ್ನು ಲೆಕ್ಕ ಹಾಕಿ SHREE RAGO ವ್ಯವಸ್ಥೆಯ ಮೂಲಕ ಹೊಂದಿಸಲಾಗುತ್ತದೆ.",
  "trust.secure.t": "ಸುರಕ್ಷಿತ ಪಾವತಿ",
  "trust.secure.d": "ಪಾವತಿಗಳನ್ನು ನಿಗದಿತ ಪಾವತಿ ಪೂರೈಕೆದಾರರ ಮೂಲಕ ಸುರಕ್ಷಿತವಾಗಿ ಸಂಸ್ಕರಿಸಲಾಗುತ್ತದೆ.",
  "trust.instant.t": "ತಕ್ಷಣ ಪ್ರವೇಶ",
  "trust.instant.d": "ಪರಿಶೀಲಿತ ಪಾವತಿಯ ನಂತರ ನಿಮಗೆ ನಿಯೋಜಿತ ಚಿತ್ರ ಡೌನ್‌ಲೋಡ್‌ಗೆ ಲಭ್ಯವಾಗುತ್ತದೆ.",
  "trust.access.t": "ಮತ್ತೆ ಪ್ರವೇಶಿಸಿ",
  "trust.access.d": "ಖರೀದಿಸಿದ ಚಿತ್ರವನ್ನು ಮತ್ತೆ ಪಡೆಯಲು ನಿಮ್ಮ ಪರಿಶೀಲಿತ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ಬಳಸಿ.",
  "trust.refund.t": "7-ದಿನಗಳ ತೃಪ್ತಿ ಭರವಸೆ",
  "trust.refund.d": "ಅರ್ಹ ಮರುಪಾವತಿ ವಿನಂತಿಗಳನ್ನು ಪ್ರಕಟಿತ ಮರುಪಾವತಿ ನೀತಿಯ ಪ್ರಕಾರ 7 ದಿನಗಳೊಳಗೆ ಸಲ್ಲಿಸಬಹುದು.",
  "trust.privacy.t": "ನಿಮ್ಮ ಗೌಪ್ಯತೆ ಮುಖ್ಯ",
  "trust.privacy.d": "ಜನ್ಮ ವಿವರಗಳು ಮತ್ತು ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಗೌಪ್ಯತಾ ನೀತಿಯ ಪ್ರಕಾರ ನಿರ್ವಹಿಸಲಾಗುತ್ತದೆ ಮತ್ತು ಸಾರ್ವಜನಿಕವಾಗಿ ಪ್ರದರ್ಶಿಸಲಾಗುವುದಿಲ್ಲ.",
  "lang.choose": "ನಿಮ್ಮ ಭಾಷೆ ಆರಿಸಿ",
  "purchase.title": "₹99ಕ್ಕೆ ನಿಮಗೆ ಏನು ಸಿಗುತ್ತದೆ",
  "purchase.i1": "ಒಂದು ವೈಯಕ್ತಿಕ ದೈವಿಕ ಚಿತ್ರ",
  "purchase.i2": "ಉನ್ನತ-ಗುಣಮಟ್ಟದ ಮೊಬೈಲ್ ಡೌನ್‌ಲೋಡ್",
  "purchase.i3": "ನಿಮ್ಮ 7-ದಿನಗಳ SHREE RAGO ಅನುಭವ",
  "purchase.i4": "ಪರಿಶೀಲಿತ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯಿಂದ ಮತ್ತೆ ಪ್ರವೇಶ",
  "purchase.i5": "ಅರ್ಹ 7-ದಿನಗಳ ಮರುಪಾವತಿ ವಿನಂತಿ",
  "purchase.onetime": "ಒಂದು ಬಾರಿ ಪಾವತಿ",
  "purchase.nosubs": "ಚಂದಾದಾರಿಕೆ ಇಲ್ಲ",
  "purchase.secure": "🔒 ಸುರಕ್ಷಿತ ಪಾವತಿ • ₹99 ಒಂದು ಬಾರಿ • 7-ದಿನಗಳ ಮರುಪಾವತಿ ನೀತಿ • HD ಡೌನ್‌ಲೋಡ್",
};

export const te = {
  "form.mobile": "మొబైల్ నంబర్",
  "form.mobile.ph": "10 అంకెల మొబైల్ నంబర్",
  "form.mobile.hint": "మీ చిత్రం పంపడానికి మరియు తర్వాత మళ్లీ యాక్సెస్ ఇవ్వడానికి మాత్రమే ఉపయోగిస్తాం.",
  "form.err.mobile": "దయచేసి చెల్లుబాటు అయ్యే 10 అంకెల మొబైల్ నంబర్ నమోదు చేయండి.",
  "coupon.have": "కూపన్ కోడ్ ఉందా?",
  "coupon.label": "కూపన్ కోడ్",
  "coupon.ph": "కోడ్ నమోదు చేయండి",
  "coupon.apply": "వర్తించు",
  "coupon.remove": "తొలగించు",
  "coupon.applied": "కూపన్ {code} వర్తించబడింది",
  "coupon.invalid": "ఈ కూపన్ కోడ్ చెల్లదు లేదా గడువు ముగిసింది.",
  "locked.cta.free": "నా చిత్రాన్ని అన్‌లాక్ చేయండి — ఉచితం",
  "access.link": "నా చిత్రాన్ని మళ్లీ చూడండి",
  "access.eyebrow": "ఇప్పటికే కొన్నారా?",
  "access.title": "మీ చిత్రాన్ని మళ్లీ పొందండి",
  "access.body": "కొనుగోలు సమయంలో ఉపయోగించిన మొబైల్ నంబర్ మరియు మీ జన్మ తేదీ నమోదు చేసి, మీ దైవిక చిత్రాన్ని మళ్లీ తెరిచి డౌన్‌లోడ్ చేసుకోండి.",
  "access.cta": "నా చిత్రాన్ని కనుగొనండి",
  "access.hint": "వీటిని మీ చెల్లించిన ఆర్డర్‌తో సరిపోల్చుతాం. ఏదీ బహిరంగం కాదు.",
  "access.err": "దయచేసి చెల్లుబాటు అయ్యే మొబైల్ నంబర్ మరియు జన్మ తేదీ నమోదు చేయండి.",
  "access.notfound": "ఈ మొబైల్ నంబర్ మరియు జన్మ తేదీకి చెల్లించిన చిత్రం కనబడలేదు.",
  "access.found": "{n} చిత్రం దొరికింది",
  "access.open": "పూర్తి పేజీ తెరవండి",
  "access.again": "మరో నంబర్ వెతకండి",
  "nav.how": "ఇది ఎలా పనిచేస్తుంది",
  "nav.experiences": "అనుభవాలు",
  "nav.faq": "ప్రశ్నలు",
  "nav.cta": "నా చిత్రాన్ని కనుగొనండి — ₹99",
  "hero.eyebrow": "మీ జన్మ వివరాల నుండి ఎంచుకున్న చిత్రం",
  "hero.title.1": "కనుగొనండి మీ",
  "hero.title.2": "వ్యక్తిగత",
  "hero.title.3": "దైవిక చిత్రం",
  "hero.support": "మీ పేరు మరియు జన్మ వివరాలు ప్రత్యేకమైనవి. SHREE RAGO తన జ్యోతిష్య మరియు సంఖ్యాశాస్త్ర ఆధారిత ఎంపిక పద్ధతితో మీ 7-రోజుల ఆధ్యాత్మిక అనుభవం కోసం ఒక వ్యక్తిగత దైవిక చిత్రాన్ని గుర్తిస్తుంది.",
  "hero.price.line1": "ఒక వ్యక్తిగత చిత్రం",
  "hero.price.line2": "కేవలం ₹99",
  "hero.cta": "నా చిత్రాన్ని కనుగొనండి",
  "hero.trust": "సుమారు 2 నిమిషాలు • సురక్షిత చెల్లింపు • తక్షణ డౌన్‌లోడ్",
  "flow.details": "మీ వివరాలు",
  "flow.analysis": "SHREE RAGO విశ్లేషణ",
  "flow.image": "మీ చిత్రం",
  "curiosity.title": "ప్రతి చిత్రం ప్రతి ఒక్కరికీ ఒకేలా అనిపించాల్సిన అవసరం లేదు.",
  "curiosity.body": "మన పేర్లు, జన్మ తేదీలు, జన్మ సమయాలు మరియు జన్మ స్థలాలు వేరువేరు. SHREE RAGO ఈ వివరాలను తన సంఖ్యాశాస్త్ర మరియు జ్యోతిష్య ఆధారిత పద్ధతిలో ఉపయోగించి మీ వ్యక్తిగత ఆధ్యాత్మిక అనుభవం కోసం ఒక చిత్రాన్ని ఎంచుకుంటుంది.",
  "curiosity.statement.1": "చిత్రాన్ని మీరు ఎంచుకోరు.",
  "curiosity.statement.2": "మీ వివరాలు ఎంపికకు మార్గం చూపుతాయి.",
  "curiosity.cta": "నా చిత్రాన్ని కనుగొనండి — ₹99",
  "how.title": "4 వివరాలు. 1 చిత్రం. 7 రోజులు.",
  "how.step1.t": "మీ పేరు",
  "how.step1.d": "మీ పూర్తి పేరు నమోదు చేయండి.",
  "how.step2.t": "మీ జన్మ వివరాలు",
  "how.step2.d": "మీ జన్మ తేదీ, ఖచ్చితమైన సమయం మరియు స్థలం నమోదు చేయండి.",
  "how.step3.t": "మీ చిత్రం ఎంపిక అవుతుంది",
  "how.step3.d": "SHREE RAGO మీ సమాచారాన్ని తన ముందే నిర్ణయించిన సంఖ్యాశాస్త్ర మరియు జ్యోతిష్య ఆధారిత సిఫార్సు వ్యవస్థ ద్వారా ప్రాసెస్ చేస్తుంది.",
  "how.step4.t": "డౌన్‌లోడ్ చేసి అనుభవించండి",
  "how.step4.d": "₹99 చెల్లించి, మీ HD చిత్రాన్ని డౌన్‌లోడ్ చేసుకుని 7 రోజులు మీ మొబైల్ వాల్‌పేపర్‌గా పెట్టుకోండి.",
  "how.cta": "నా 7-రోజుల అనుభవం ప్రారంభించండి",
  "how.flow.1": "వివరాలు నమోదు",
  "how.flow.2": "విశ్లేషణ",
  "how.flow.3": "₹99 చెల్లింపు",
  "how.flow.4": "డౌన్‌లోడ్",
  "how.flow.5": "7 రోజులు",
  "form.title": "మీ చిత్రాన్ని కనుగొందాం.",
  "form.subtitle": "క్రింద మీ జన్మ వివరాలు నమోదు చేయండి.",
  "form.name": "పూర్తి పేరు",
  "form.name.ph": "మీ పూర్తి పేరు నమోదు చేయండి",
  "form.dob": "జన్మ తేదీ",
  "form.time": "జన్మ సమయం",
  "form.unknown": "నా ఖచ్చితమైన జన్మ సమయం నాకు తెలియదు",
  "form.place": "జన్మ స్థలం",
  "form.place.ph": "నగరం, రాష్ట్రం",
  "form.language": "ఇష్టమైన భాష",
  "form.submit": "నా వివరాలను విశ్లేషించండి",
  "form.privacy": "మీ సమాచారం మీ ఫలితాన్ని రూపొందించడానికే ఉపయోగించబడుతుంది మరియు మా గోప్యతా విధానం ప్రకారం నిర్వహించబడుతుంది.",
  "form.err.required": "దయచేసి పేరు, జన్మ తేదీ మరియు జన్మ స్థలం నింపండి.",
  "form.err.generic": "ఏదో తప్పు జరిగింది. దయచేసి మళ్లీ ప్రయత్నించండి.",
  "analysis.1": "మీ జన్మ వివరాలు చదువుతున్నాం...",
  "analysis.2": "మీ సంఖ్యాశాస్త్రం లెక్కిస్తున్నాం...",
  "analysis.3": "మీ జ్యోతిష్య సమాచారం ప్రాసెస్ చేస్తున్నాం...",
  "analysis.4": "మీ ఆధ్యాత్మిక చిత్రాన్ని సరిపోల్చుతున్నాం...",
  "analysis.5": "మీ SHREE RAGO చిత్రం గుర్తించబడింది.",
  "locked.ready": "మీ వ్యక్తిగత చిత్రం సిద్ధంగా ఉంది.",
  "locked.title": "మీ చిత్రం వేచి ఉంది.",
  "locked.body": "మీ వ్యక్తిగత అధిక-నాణ్యత దైవిక చిత్రాన్ని అన్‌లాక్ చేసి మీ 7-రోజుల అనుభవం ప్రారంభించండి.",
  "locked.cta": "నా చిత్రాన్ని అన్‌లాక్ చేయండి — ₹99",
  "locked.trust": "సురక్షిత చెల్లింపు • తక్షణ యాక్సెస్ • HD డౌన్‌లోడ్",
  "pay.title": "ఆర్డర్ సారాంశం",
  "pay.item": "SHREE RAGO — వ్యక్తిగత దైవిక చిత్రం",
  "pay.total": "మొత్తం",
  "pay.no_hidden": "దాచిన ఛార్జీలు లేవు.",
  "pay.cta": "₹99 చెల్లించి అన్‌లాక్ చేయండి",
  "pay.success_demo": "చెల్లింపు విజయవంతం (డెమో మోడ్).",
  "pay.failed": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
  "result.title": "మీ SHREE RAGO చిత్రం",
  "result.selected_for": "వీరి కోసం ఎంపిక చేయబడింది",
  "result.download": "HD చిత్రం డౌన్‌లోడ్ చేయండి",
  "result.howto": "ఎలా ఉపయోగించాలి",
  "result.setwallpaper": "వాల్‌పేపర్‌గా పెట్టుకోండి • 7 రోజులు గమనించండి",
  "result.revealing": "✧ ప్రకటిస్తున్నాం ✧",
  "result.back": "← హోమ్‌కు తిరిగి వెళ్ళండి",
  "common.loading": "లోడ్ అవుతోంది…",
  "seven.title": "మీ తదుపరి 7 రోజులు",
  "seven.i1": "మీ SHREE RAGO చిత్రాన్ని డౌన్‌లోడ్ చేయండి.",
  "seven.i2": "దాన్ని మీ మొబైల్ లాక్ స్క్రీన్ లేదా వాల్‌పేపర్‌గా పెట్టుకోండి.",
  "seven.i3": "తదుపరి 7 రోజులు దాన్ని ఉంచుకోండి.",
  "seven.i4": "ప్రతిరోజూ ఒక క్షణం చిత్రాన్ని శ్రద్ధగా గమనించండి.",
  "seven.i5": "7వ రోజు చివరన మీ వ్యక్తిగత అనుభవాన్ని పరిశీలించండి.",
  "seven.motto.1": "7 రోజులు.",
  "seven.motto.2": "ఒక చిత్రం.",
  "seven.motto.3": "మీ అనుభవం.",
  "seven.cta": "నా చిత్రాన్ని డౌన్‌లోడ్ చేయండి",
  "trad.title": "సంప్రదాయంలో పాతుకుపోయింది. సాంకేతికత ద్వారా అందించబడింది.",
  "trad.body": "భారతదేశంలో జ్యోతిష్యం, సంఖ్యాశాస్త్రం, భక్తి ఆచారాలు మరియు పవిత్ర చిత్రాలకు శతాబ్దాల నాటి సంప్రదాయాలు ఉన్నాయి. SHREE RAGO ఈ సంప్రదాయాల ప్రేరణను ఒక సరళ డిజిటల్ అనుభవంగా అందిస్తుంది.",
  "collection.title": "భక్తితో రూపొందించబడింది. మీ కోసం ఎంపిక చేయబడింది.",
  "collection.sub": "9 సంఖ్యాశాస్త్ర వర్గాలలో సేకరించిన ప్రీమియం 9:16 దైవిక కళాఖండాలు.",
  "collection.your": "మీ చిత్రం?",
  "collection.cta": "నాది కనుగొనండి",
  "trust.title": "ప్రజలు SHREE RAGO ను ఎందుకు నమ్ముతారు",
  "testimonials.title": "నిజమైన వ్యక్తులు. నిజమైన అనుభవాలు.",
  "testimonials.sub": "నిజమైన సాధకుల ప్రామాణిక అనుభవాలు.",
  "testimonials.more": "మరిన్ని అనుభవాలు చూడండి",
  "testimonials.coming": "కస్టమర్ అనుభవాలు త్వరలో వస్తున్నాయి.",
  "testimonials.verified": "✓ ధృవీకరించిన కస్టమర్",
  "why.title": "సరళ అనుభవం. సరళ ధర.",
  "why.body": "సబ్‌స్క్రిప్షన్ లేదు. సంప్రదింపులు లేవు. సంక్లిష్ట ప్యాకేజీలు లేవు. ఒక వ్యక్తిగత చిత్రం. ఒక చెల్లింపు. తక్షణ డౌన్‌లోడ్. 7-రోజుల అనుభవం.",
  "why.cta": "నా చిత్రం పొందండి — ₹99",
  "privacy.title": "మీ జన్మ వివరాలు వ్యక్తిగతమైనవి.",
  "privacy.body": "సేవ అందించడానికి అవసరమైన సమాచారాన్ని మాత్రమే మేము సేకరిస్తాము.",
  "faq.title": "ప్రశ్నలు?",
  "faq.q1": "SHREE RAGO అంటే ఏమిటి?",
  "faq.a1": "SHREE RAGO ఒక వ్యక్తిగత ఆధ్యాత్మిక-చిత్ర అనుభవం. మీరు ఇచ్చిన జన్మ వివరాలను మా సంఖ్యాశాస్త్ర మరియు జ్యోతిష్య ఆధారిత ఎంపిక పద్ధతిలో ఉపయోగించి మీ కోసం ఒక చిత్రాన్ని గుర్తిస్తుంది.",
  "faq.q2": "నాకు ఏ వివరాలు కావాలి?",
  "faq.a2": "మీ పూర్తి పేరు, జన్మ తేదీ, జన్మ సమయం మరియు జన్మ స్థలం.",
  "faq.q3": "దీని ధర ఎంత?",
  "faq.a3": "ఒక వ్యక్తిగత అధిక-నాణ్యత డిజిటల్ చిత్రానికి ₹99.",
  "faq.q4": "నాకు ఏమి లభిస్తుంది?",
  "faq.a4": "మీ మొబైల్‌కు డౌన్‌లోడ్ చేసుకోగల ఒక వ్యక్తిగత దైవిక చిత్రం మీకు లభిస్తుంది.",
  "faq.q5": "నేను దీన్ని ఎలా ఉపయోగించాలి?",
  "faq.a5": "డౌన్‌లోడ్ చేసిన చిత్రాన్ని 7 రోజులు మీ మొబైల్ వాల్‌పేపర్ లేదా లాక్ స్క్రీన్‌గా పెట్టుకుని మీ వ్యక్తిగత అనుభవాన్ని గమనించండి.",
  "faq.q6": "నాకు ఖచ్చితంగా ఒక ప్రత్యేక ఫలితం లభిస్తుందా?",
  "faq.a6": "వ్యక్తిగత అనుభవాలు వేరువేరు. SHREE RAGO ఒక ఆధ్యాత్మిక మరియు ఆత్మపరిశీలన అనుభవం; ఇది ఆర్థిక, వైద్య, సంబంధ, కెరీర్ లేదా ఇతర ప్రత్యేక ఫలితాలకు హామీ ఇవ్వదు.",
  "faq.q7": "ఇది వైద్య లేదా ఆర్థిక సలహా?",
  "faq.a7": "కాదు. SHREE RAGO వృత్తిపరమైన వైద్య, మానసిక, ఆర్థిక, న్యాయ లేదా ఇతర సలహాకు ప్రత్యామ్నాయం కాదు.",
  "faq.q8": "నేను వెంటనే డౌన్‌లోడ్ చేసుకోవచ్చా?",
  "faq.a8": "అవును. విజయవంతమైన చెల్లింపు తర్వాత మీ చిత్రం తక్షణ డౌన్‌లోడ్‌కు అందుబాటులో ఉంటుంది.",
  "faq.q9": "నా చిత్రాన్ని పంచుకోవచ్చా?",
  "faq.a9": "కొనుగోలు చేసిన చిత్రం కస్టమర్ వ్యక్తిగత వినియోగానికి లైసెన్స్ పొందింది. పంచుకునేటప్పుడు మీ వ్యక్తిగత జన్మ సమాచారాన్ని బహిర్గతం చేయకండి.",
  "final.title": "మీ వివరాలు ప్రత్యేకమైనవి.",
  "final.sub": "మీ 7-రోజుల SHREE RAGO అనుభవం కోసం ఎంపిక చేసిన చిత్రాన్ని కనుగొనండి.",
  "final.cta": "నా చిత్రాన్ని కనుగొనండి",
  "final.trust": "2 నిమిషాలు • సురక్షిత చెల్లింపు • తక్షణ డౌన్‌లోడ్",
  "footer.tagline": "మీ వ్యక్తిగత దైవిక చిత్రం",
  "footer.disclaimer": "SHREE RAGO ఒక ఆధ్యాత్మిక మరియు ఆత్మపరిశీలన అనుభవాన్ని అందిస్తుంది. జ్యోతిష్య మరియు సంఖ్యాశాస్త్ర వివరణలు నమ్మకం ఆధారితమైనవి; వాటిని ఖచ్చితమైన అంచనాలుగా లేదా వృత్తిపరమైన సలహాకు ప్రత్యామ్నాయంగా పరిగణించకూడదు.",
  "footer.how": "ఇది ఎలా పనిచేస్తుంది",
  "footer.faq": "ప్రశ్నలు",
  "footer.privacy": "గోప్యతా విధానం",
  "footer.terms": "నియమాలు & షరతులు",
  "footer.shipping": "షిప్పింగ్ & డెలివరీ",
  "footer.refund": "రీఫండ్ & రద్దు",
  "footer.contact": "సంప్రదించండి",
  "footer.rights": "అన్ని హక్కులు రిజర్వ్ చేయబడ్డాయి.",
  "trust.oneprice.t": "ఒక స్పష్టమైన ధర",
  "trust.oneprice.d": "₹99. దాచిన సబ్‌స్క్రిప్షన్ లేదు. పునరావృత చెల్లింపు లేదు.",
  "trust.personal.t": "మీ వ్యక్తిగత చిత్రం",
  "trust.personal.d": "మీరు సమర్పించిన జన్మ సమాచారం నుండి మీ ఫలితం లెక్కించబడి SHREE RAGO వ్యవస్థ ద్వారా మ్యాప్ చేయబడుతుంది.",
  "trust.secure.t": "సురక్షిత చెల్లింపు",
  "trust.secure.d": "చెల్లింపులు నిర్దేశిత చెల్లింపు ప్రొవైడర్ ద్వారా సురక్షితంగా ప్రాసెస్ చేయబడతాయి.",
  "trust.instant.t": "తక్షణ యాక్సెస్",
  "trust.instant.d": "ధృవీకరించిన చెల్లింపు తర్వాత మీకు కేటాయించిన చిత్రం డౌన్‌లోడ్‌కు అందుబాటులో ఉంటుంది.",
  "trust.access.t": "మళ్లీ యాక్సెస్",
  "trust.access.d": "కొనుగోలు చేసిన చిత్రాన్ని మళ్లీ పొందడానికి మీ ధృవీకరించిన మొబైల్ నంబర్‌ను ఉపయోగించండి.",
  "trust.refund.t": "7-రోజుల సంతృప్తి హామీ",
  "trust.refund.d": "అర్హత గల రీఫండ్ అభ్యర్థనలను ప్రచురించిన రీఫండ్ విధానం ప్రకారం 7 రోజుల్లో సమర్పించవచ్చు.",
  "trust.privacy.t": "మీ గోప్యత ముఖ్యం",
  "trust.privacy.d": "జన్మ వివరాలు మరియు వ్యక్తిగత సమాచారం గోప్యతా విధానం ప్రకారం నిర్వహించబడతాయి మరియు బహిరంగంగా ప్రదర్శించబడవు.",
  "lang.choose": "మీ భాషను ఎంచుకోండి",
  "purchase.title": "₹99కి మీకు ఏమి లభిస్తుంది",
  "purchase.i1": "ఒక వ్యక్తిగత దైవిక చిత్రం",
  "purchase.i2": "అధిక-నాణ్యత మొబైల్ డౌన్‌లోడ్",
  "purchase.i3": "మీ 7-రోజుల SHREE RAGO అనుభవం",
  "purchase.i4": "ధృవీకరించిన మొబైల్ నంబర్‌తో మళ్లీ యాక్సెస్",
  "purchase.i5": "అర్హత గల 7-రోజుల రీఫండ్ అభ్యర్థన",
  "purchase.onetime": "ఒకసారి చెల్లింపు",
  "purchase.nosubs": "సబ్‌స్క్రిప్షన్ లేదు",
  "purchase.secure": "🔒 సురక్షిత చెల్లింపు • ₹99 ఒకసారి • 7-రోజుల రీఫండ్ విధానం • HD డౌన్‌లోడ్",
};

export const ta = {
  "form.mobile": "மொபைல் எண்",
  "form.mobile.ph": "10 இலக்க மொபைல் எண்",
  "form.mobile.hint": "உங்கள் படத்தை அனுப்பவும், பின்னர் மீண்டும் அணுகவும் மட்டுமே பயன்படுத்தப்படும்.",
  "form.err.mobile": "சரியான 10 இலக்க மொபைல் எண்ணை உள்ளிடுங்கள்.",
  "coupon.have": "கூப்பன் குறியீடு உள்ளதா?",
  "coupon.label": "கூப்பன் குறியீடு",
  "coupon.ph": "குறியீட்டை உள்ளிடுங்கள்",
  "coupon.apply": "பயன்படுத்து",
  "coupon.remove": "நீக்கு",
  "coupon.applied": "கூப்பன் {code} பயன்படுத்தப்பட்டது",
  "coupon.invalid": "இந்த கூப்பன் குறியீடு தவறானது அல்லது காலாவதியானது.",
  "locked.cta.free": "எனது படத்தைத் திற — இலவசம்",
  "access.link": "எனது படத்தை மீண்டும் பார்",
  "access.eyebrow": "ஏற்கனவே வாங்கியுள்ளீர்களா?",
  "access.title": "உங்கள் படத்தை மீண்டும் பெறுங்கள்",
  "access.body": "வாங்கும்போது பயன்படுத்திய மொபைல் எண் மற்றும் உங்கள் பிறந்த தேதியை உள்ளிட்டு, உங்கள் தெய்வீக படத்தை மீண்டும் திறந்து பதிவிறக்குங்கள்.",
  "access.cta": "எனது படத்தைக் கண்டறி",
  "access.hint": "இவற்றை உங்கள் கட்டணம் செலுத்திய ஆர்டருடன் பொருத்துகிறோம். எதுவும் பொதுவில் வெளியிடப்படாது.",
  "access.err": "சரியான மொபைல் எண் மற்றும் பிறந்த தேதியை உள்ளிடுங்கள்.",
  "access.notfound": "இந்த மொபைல் எண் மற்றும் பிறந்த தேதிக்கு கட்டணம் செலுத்திய படம் இல்லை.",
  "access.found": "{n} படம் கிடைத்தது",
  "access.open": "முழுப் பக்கத்தைத் திற",
  "access.again": "வேறு எண்ணைத் தேடு",
  "nav.how": "இது எப்படி செயல்படுகிறது",
  "nav.experiences": "அனுபவங்கள்",
  "nav.faq": "கேள்விகள்",
  "nav.cta": "எனது படத்தைக் கண்டறியவும் — ₹99",
  "hero.eyebrow": "உங்கள் பிறப்பு விவரங்களிலிருந்து தேர்ந்தெடுக்கப்பட்ட படம்",
  "hero.title.1": "கண்டறியுங்கள் உங்கள்",
  "hero.title.2": "தனிப்பட்ட",
  "hero.title.3": "தெய்வீக படம்",
  "hero.support": "உங்கள் பெயர் மற்றும் பிறப்பு விவரங்கள் தனித்துவமானவை. SHREE RAGO தனது ஜோதிடம் மற்றும் எண் கணித அடிப்படையிலான தேர்வு முறையால் உங்கள் 7-நாள் ஆன்மீக அனுபவத்திற்காக ஒரு தனிப்பட்ட தெய்வீக படத்தை அடையாளம் காண்கிறது.",
  "hero.price.line1": "ஒரு தனிப்பட்ட படம்",
  "hero.price.line2": "வெறும் ₹99",
  "hero.cta": "எனது படத்தைக் கண்டறியவும்",
  "hero.trust": "சுமார் 2 நிமிடங்கள் • பாதுகாப்பான கட்டணம் • உடனடி பதிவிறக்கம்",
  "flow.details": "உங்கள் விவரங்கள்",
  "flow.analysis": "SHREE RAGO பகுப்பாய்வு",
  "flow.image": "உங்கள் படம்",
  "curiosity.title": "ஒவ்வொரு படமும் ஒவ்வொருவருக்கும் ஒரே மாதிரி தோன்ற வேண்டியதில்லை.",
  "curiosity.body": "நமது பெயர்கள், பிறந்த தேதிகள், பிறந்த நேரங்கள் மற்றும் பிறந்த இடங்கள் வேறுபட்டவை. SHREE RAGO இந்த விவரங்களை தனது எண் கணிதம் மற்றும் ஜோதிட அடிப்படையிலான முறையில் பயன்படுத்தி உங்கள் தனிப்பட்ட ஆன்மீக அனுபவத்திற்காக ஒரு படத்தைத் தேர்ந்தெடுக்கிறது.",
  "curiosity.statement.1": "படத்தை நீங்கள் தேர்ந்தெடுக்கவில்லை.",
  "curiosity.statement.2": "உங்கள் விவரங்கள் தேர்வை வழிநடத்துகின்றன.",
  "curiosity.cta": "எனது படத்தைக் கண்டறியவும் — ₹99",
  "how.title": "4 விவரங்கள். 1 படம். 7 நாட்கள்.",
  "how.step1.t": "உங்கள் பெயர்",
  "how.step1.d": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்.",
  "how.step2.t": "உங்கள் பிறப்பு விவரங்கள்",
  "how.step2.d": "உங்கள் பிறந்த தேதி, சரியான நேரம் மற்றும் இடத்தை உள்ளிடுங்கள்.",
  "how.step3.t": "உங்கள் படம் தேர்ந்தெடுக்கப்படுகிறது",
  "how.step3.d": "SHREE RAGO உங்கள் தகவலை தனது முன்வரையறுக்கப்பட்ட எண் கணிதம் மற்றும் ஜோதிட அடிப்படையிலான பரிந்துரை அமைப்பின் மூலம் செயலாக்குகிறது.",
  "how.step4.t": "பதிவிறக்கி அனுபவியுங்கள்",
  "how.step4.d": "₹99 செலுத்தி, உங்கள் HD படத்தைப் பதிவிறக்கி 7 நாட்களுக்கு உங்கள் மொபைல் வால்பேப்பராக வைத்துக்கொள்ளுங்கள்.",
  "how.cta": "எனது 7-நாள் அனுபவத்தைத் தொடங்கு",
  "how.flow.1": "விவரங்களை உள்ளிடு",
  "how.flow.2": "பகுப்பாய்வு",
  "how.flow.3": "₹99 கட்டணம்",
  "how.flow.4": "பதிவிறக்கம்",
  "how.flow.5": "7 நாட்கள்",
  "form.title": "உங்கள் படத்தைக் கண்டறிவோம்.",
  "form.subtitle": "கீழே உங்கள் பிறப்பு விவரங்களை உள்ளிடுங்கள்.",
  "form.name": "முழுப் பெயர்",
  "form.name.ph": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "form.dob": "பிறந்த தேதி",
  "form.time": "பிறந்த நேரம்",
  "form.unknown": "எனது சரியான பிறந்த நேரம் எனக்குத் தெரியாது",
  "form.place": "பிறந்த இடம்",
  "form.place.ph": "நகரம், மாநிலம்",
  "form.language": "விருப்ப மொழி",
  "form.submit": "எனது விவரங்களைப் பகுப்பாய்வு செய்",
  "form.privacy": "உங்கள் தகவல் உங்கள் முடிவை உருவாக்க மட்டுமே பயன்படுத்தப்படும், மேலும் எங்கள் தனியுரிமைக் கொள்கையின்படி கையாளப்படும்.",
  "form.err.required": "பெயர், பிறந்த தேதி மற்றும் பிறந்த இடத்தை நிரப்புங்கள்.",
  "form.err.generic": "ஏதோ தவறு ஏற்பட்டது. மீண்டும் முயற்சிக்கவும்.",
  "analysis.1": "உங்கள் பிறப்பு விவரங்களைப் படிக்கிறோம்...",
  "analysis.2": "உங்கள் எண் கணிதத்தைக் கணக்கிடுகிறோம்...",
  "analysis.3": "உங்கள் ஜோதிடத் தகவல்களைச் செயலாக்குகிறோம்...",
  "analysis.4": "உங்கள் ஆன்மீகப் படத்தைப் பொருத்துகிறோம்...",
  "analysis.5": "உங்கள் SHREE RAGO படம் அடையாளம் காணப்பட்டது.",
  "locked.ready": "உங்கள் தனிப்பட்ட படம் தயார்.",
  "locked.title": "உங்கள் படம் காத்திருக்கிறது.",
  "locked.body": "உங்கள் தனிப்பட்ட உயர்தர தெய்வீக படத்தைத் திறந்து உங்கள் 7-நாள் அனுபவத்தைத் தொடங்குங்கள்.",
  "locked.cta": "எனது படத்தைத் திற — ₹99",
  "locked.trust": "பாதுகாப்பான கட்டணம் • உடனடி அணுகல் • HD பதிவிறக்கம்",
  "pay.title": "ஆர்டர் சுருக்கம்",
  "pay.item": "SHREE RAGO — தனிப்பட்ட தெய்வீக படம்",
  "pay.total": "மொத்தம்",
  "pay.no_hidden": "மறைமுகக் கட்டணங்கள் இல்லை.",
  "pay.cta": "₹99 செலுத்தித் திற",
  "pay.success_demo": "கட்டணம் வெற்றி (டெமோ முறை).",
  "pay.failed": "கட்டணம் தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.",
  "result.title": "உங்கள் SHREE RAGO படம்",
  "result.selected_for": "இவருக்காகத் தேர்ந்தெடுக்கப்பட்டது",
  "result.download": "HD படத்தைப் பதிவிறக்கு",
  "result.howto": "எப்படிப் பயன்படுத்துவது",
  "result.setwallpaper": "வால்பேப்பராக அமை • 7 நாட்கள் கவனி",
  "result.revealing": "✧ வெளிப்படுகிறது ✧",
  "result.back": "← முகப்புக்குத் திரும்பு",
  "common.loading": "ஏற்றுகிறது…",
  "seven.title": "உங்கள் அடுத்த 7 நாட்கள்",
  "seven.i1": "உங்கள் SHREE RAGO படத்தைப் பதிவிறக்குங்கள்.",
  "seven.i2": "அதை உங்கள் மொபைல் லாக் ஸ்கிரீன் அல்லது வால்பேப்பராக அமையுங்கள்.",
  "seven.i3": "அடுத்த 7 நாட்களுக்கு அதை வைத்திருங்கள்.",
  "seven.i4": "ஒவ்வொரு நாளும் ஒரு கணம் படத்தைக் கவனமாகப் பாருங்கள்.",
  "seven.i5": "7ஆம் நாள் முடிவில் உங்கள் தனிப்பட்ட அனுபவத்தைச் சிந்தியுங்கள்.",
  "seven.motto.1": "7 நாட்கள்.",
  "seven.motto.2": "ஒரு படம்.",
  "seven.motto.3": "உங்கள் அனுபவம்.",
  "seven.cta": "எனது படத்தைப் பதிவிறக்கு",
  "trad.title": "மரபில் வேரூன்றியது. தொழில்நுட்பத்தால் வழங்கப்படுகிறது.",
  "trad.body": "இந்தியாவில் ஜோதிடம், எண் கணிதம், பக்தி வழிபாடுகள் மற்றும் புனிதப் படங்கள் சார்ந்த நூற்றாண்டுகள் பழமையான மரபுகள் உள்ளன. SHREE RAGO இந்த மரபுகளின் ஊக்கத்தை ஒரு எளிய டிஜிட்டல் அனுபவமாகக் கொண்டுவருகிறது.",
  "collection.title": "பக்தியுடன் உருவாக்கப்பட்டது. உங்களுக்காகத் தேர்ந்தெடுக்கப்பட்டது.",
  "collection.sub": "9 எண் கணிதப் பிரிவுகளில் தொகுக்கப்பட்ட பிரீமியம் 9:16 தெய்வீகக் கலைப்படைப்புகள்.",
  "collection.your": "உங்கள் படம்?",
  "collection.cta": "எனதைக் கண்டறி",
  "trust.title": "மக்கள் SHREE RAGO ஐ ஏன் நம்புகிறார்கள்",
  "testimonials.title": "உண்மையான மக்கள். உண்மையான அனுபவங்கள்.",
  "testimonials.sub": "உண்மையான சாதகர்களின் நேர்மையான அனுபவங்கள்.",
  "testimonials.more": "மேலும் அனுபவங்களைப் பார்",
  "testimonials.coming": "வாடிக்கையாளர் அனுபவங்கள் விரைவில்.",
  "testimonials.verified": "✓ சரிபார்க்கப்பட்ட வாடிக்கையாளர்",
  "why.title": "எளிய அனுபவம். எளிய விலை.",
  "why.body": "சந்தா இல்லை. ஆலோசனை இல்லை. சிக்கலான தொகுப்புகள் இல்லை. ஒரு தனிப்பட்ட படம். ஒரு கட்டணம். உடனடி பதிவிறக்கம். 7-நாள் அனுபவம்.",
  "why.cta": "எனது படத்தைப் பெறு — ₹99",
  "privacy.title": "உங்கள் பிறப்பு விவரங்கள் தனிப்பட்டவை.",
  "privacy.body": "சேவையை வழங்கத் தேவையான தகவல்களை மட்டுமே நாங்கள் சேகரிக்கிறோம்.",
  "faq.title": "கேள்விகள்?",
  "faq.q1": "SHREE RAGO என்றால் என்ன?",
  "faq.a1": "SHREE RAGO ஒரு தனிப்பட்ட ஆன்மீகப் பட அனுபவம். நீங்கள் வழங்கும் பிறப்பு விவரங்களை எங்கள் எண் கணிதம் மற்றும் ஜோதிட அடிப்படையிலான தேர்வு முறையில் பயன்படுத்தி உங்களுக்காக ஒரு படத்தை அடையாளம் காண்கிறது.",
  "faq.q2": "எனக்கு என்ன விவரங்கள் தேவை?",
  "faq.a2": "உங்கள் முழுப் பெயர், பிறந்த தேதி, பிறந்த நேரம் மற்றும் பிறந்த இடம்.",
  "faq.q3": "இதன் விலை என்ன?",
  "faq.a3": "ஒரு தனிப்பட்ட உயர்தர டிஜிட்டல் படத்திற்கு ₹99.",
  "faq.q4": "நான் என்ன பெறுவேன்?",
  "faq.a4": "உங்கள் மொபைலில் பதிவிறக்கக்கூடிய ஒரு தனிப்பட்ட தெய்வீக படத்தைப் பெறுவீர்கள்.",
  "faq.q5": "நான் இதை எப்படிப் பயன்படுத்த வேண்டும்?",
  "faq.a5": "பதிவிறக்கிய படத்தை 7 நாட்களுக்கு உங்கள் மொபைல் வால்பேப்பர் அல்லது லாக் ஸ்கிரீனாக அமைத்து உங்கள் தனிப்பட்ட அனுபவத்தைக் கவனியுங்கள்.",
  "faq.q6": "எனக்கு நிச்சயமாக ஒரு குறிப்பிட்ட பலன் கிடைக்குமா?",
  "faq.a6": "தனிப்பட்ட அனுபவங்கள் வேறுபடும். SHREE RAGO ஒரு ஆன்மீக மற்றும் சுய-சிந்தனை அனுபவம்; இது நிதி, மருத்துவம், உறவு, தொழில் அல்லது வேறு எந்தக் குறிப்பிட்ட பலனையும் உறுதி செய்யாது.",
  "faq.q7": "இது மருத்துவ அல்லது நிதி ஆலோசனையா?",
  "faq.a7": "இல்லை. SHREE RAGO தொழில்முறை மருத்துவ, மனநல, நிதி, சட்ட அல்லது பிற ஆலோசனைக்கு மாற்று அல்ல.",
  "faq.q8": "உடனடியாகப் பதிவிறக்க முடியுமா?",
  "faq.a8": "ஆம். வெற்றிகரமான கட்டணத்திற்குப் பிறகு உங்கள் படம் உடனடிப் பதிவிறக்கத்திற்குக் கிடைக்கும்.",
  "faq.q9": "எனது படத்தைப் பகிரலாமா?",
  "faq.a9": "வாங்கிய படம் வாடிக்கையாளரின் தனிப்பட்ட பயன்பாட்டிற்கு உரிமம் பெற்றது. பகிரும்போது உங்கள் தனிப்பட்ட பிறப்புத் தகவலை வெளிப்படுத்த வேண்டாம்.",
  "final.title": "உங்கள் விவரங்கள் தனித்துவமானவை.",
  "final.sub": "உங்கள் 7-நாள் SHREE RAGO அனுபவத்திற்காகத் தேர்ந்தெடுக்கப்பட்ட படத்தைக் கண்டறியுங்கள்.",
  "final.cta": "எனது படத்தைக் கண்டறியவும்",
  "final.trust": "2 நிமிடங்கள் • பாதுகாப்பான கட்டணம் • உடனடி பதிவிறக்கம்",
  "footer.tagline": "உங்கள் தனிப்பட்ட தெய்வீக படம்",
  "footer.disclaimer": "SHREE RAGO ஒரு ஆன்மீக மற்றும் சுய-சிந்தனை அனுபவத்தை வழங்குகிறது. ஜோதிடம் மற்றும் எண் கணித விளக்கங்கள் நம்பிக்கை அடிப்படையிலானவை; அவற்றை உறுதியான கணிப்புகளாகவோ தொழில்முறை ஆலோசனைக்கு மாற்றாகவோ கருதக்கூடாது.",
  "footer.how": "இது எப்படி செயல்படுகிறது",
  "footer.faq": "கேள்விகள்",
  "footer.privacy": "தனியுரிமைக் கொள்கை",
  "footer.terms": "விதிமுறைகள் & நிபந்தனைகள்",
  "footer.shipping": "ஷிப்பிங் & டெலிவரி",
  "footer.refund": "பணத்திரும்பம் & ரத்து",
  "footer.contact": "தொடர்பு",
  "footer.rights": "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
  "trust.oneprice.t": "ஒரு தெளிவான விலை",
  "trust.oneprice.d": "₹99. மறைமுக சந்தா இல்லை. தொடர் கட்டணம் இல்லை.",
  "trust.personal.t": "உங்கள் தனிப்பட்ட படம்",
  "trust.personal.d": "நீங்கள் சமர்ப்பிக்கும் பிறப்புத் தகவலிலிருந்து உங்கள் முடிவு கணக்கிடப்பட்டு SHREE RAGO அமைப்பின் மூலம் பொருத்தப்படுகிறது.",
  "trust.secure.t": "பாதுகாப்பான கட்டணம்",
  "trust.secure.d": "கட்டணங்கள் நிர்ணயிக்கப்பட்ட கட்டண வழங்குநர் மூலம் பாதுகாப்பாகச் செயலாக்கப்படுகின்றன.",
  "trust.instant.t": "உடனடி அணுகல்",
  "trust.instant.d": "சரிபார்க்கப்பட்ட கட்டணத்திற்குப் பிறகு உங்களுக்கு ஒதுக்கப்பட்ட படம் பதிவிறக்கத்திற்குக் கிடைக்கும்.",
  "trust.access.t": "மீண்டும் அணுகல்",
  "trust.access.d": "வாங்கிய படத்தை மீண்டும் பெற உங்கள் சரிபார்க்கப்பட்ட மொபைல் எண்ணைப் பயன்படுத்துங்கள்.",
  "trust.refund.t": "7-நாள் திருப்தி உறுதிமொழி",
  "trust.refund.d": "தகுதியான பணத்திரும்பக் கோரிக்கைகளை வெளியிடப்பட்ட பணத்திரும்பக் கொள்கையின்படி 7 நாட்களுக்குள் சமர்ப்பிக்கலாம்.",
  "trust.privacy.t": "உங்கள் தனியுரிமை முக்கியம்",
  "trust.privacy.d": "பிறப்பு விவரங்கள் மற்றும் தனிப்பட்ட தகவல்கள் தனியுரிமைக் கொள்கையின்படி கையாளப்படுகின்றன; பொதுவில் காட்டப்படுவதில்லை.",
  "lang.choose": "உங்கள் மொழியைத் தேர்ந்தெடுங்கள்",
  "purchase.title": "₹99க்கு நீங்கள் பெறுவது",
  "purchase.i1": "ஒரு தனிப்பட்ட தெய்வீக படம்",
  "purchase.i2": "உயர்தர மொபைல் பதிவிறக்கம்",
  "purchase.i3": "உங்கள் 7-நாள் SHREE RAGO அனுபவம்",
  "purchase.i4": "சரிபார்க்கப்பட்ட மொபைல் எண்ணுடன் மீண்டும் அணுகல்",
  "purchase.i5": "தகுதியான 7-நாள் பணத்திரும்பக் கோரிக்கை",
  "purchase.onetime": "ஒருமுறைக் கட்டணம்",
  "purchase.nosubs": "சந்தா இல்லை",
  "purchase.secure": "🔒 பாதுகாப்பான கட்டணம் • ₹99 ஒருமுறை • 7-நாள் பணத்திரும்பக் கொள்கை • HD பதிவிறக்கம்",
};
